import DOMPurify from 'dompurify';

const getFileExtension = (path) => {
  const match = path.match(/\.([0-9a-z]+)(?:[\\?#]|$)/i);
  return match ? match[1] : null;
};

const base64Prefix = 'data:image/svg+xml;base64,';

const isBase64Svg = (src) => src.startsWith(base64Prefix);

const createImgEle = (src, altText) => {
  const ele = document.createElement('img');
  ele.setAttribute('src', src);
  ele.setAttribute('alt', altText);
  return ele;
};

const createSvgEle = (text) => {
  // we want to purify the SVG to avoid XSS attacks
  const clean = DOMPurify.sanitize(text, {
    USE_PROFILES: { svg: true, svgFilters: true },
    // allow image to render
    ADD_TAGS: ['image'],
    // forbid interactiviy via `use` tags (which are sanitized by default)
    FORBID_TAGS: ['defs']
  });

  const parser = new DOMParser();
  const ele = parser
    .parseFromString(clean, 'image/svg+xml')
    .querySelector('svg');
  return ele;
};

export const createImage = async (src, altText) => {
  try {
    let ele;
    if (isBase64Svg(src)) {
      // handle base64 source
      const svgXml = atob(src.slice(base64Prefix.length));
      ele = createSvgEle(svgXml);
    } else if (getFileExtension(src) === 'svg') {
      // handle urls
      const fetchedSrc = await fetch(src);
      const text = await fetchedSrc.text();
      ele = createSvgEle(text);
    } else {
      // handle binary
      ele = createImgEle(src, altText);
    }

    ele.style.setProperty('max-width', '100%');
    ele.style.setProperty('max-height', '100%');

    return ele;
  } catch {
    return null;
  }
};
